import React from 'react'
import { Route, Redirect } from 'react-router-dom'
import Page from '../components/Page'
import { hasAuthToken } from '../helpers'

const PrivateRoute = ({ component: Component, title, ...rest }) => {
   return (
      <Route
         {...rest}
         render={(props) =>
            hasAuthToken() ? (
               <Page title={title} auth>
                  <Component {...props} />
               </Page>
            ) : (
               <Redirect
                  to={{
                     pathname: '/',
                     state: { from: props.location }
                  }}
               />
            )
         }
      />
   )
}

export default PrivateRoute
